// removed by extract-text-webpack-plugin
module.exports = {"widgetWrapper":"_3ba6Q3AyV2wZ_FDgiRl9MN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/WhatsAppWidget/WhatsAppWidget.scss
// module id = 1800
// module chunks = 0